module.exports = __webpack_public_path__ + "img/2.7423c358.png";